var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link ui-link",attrs:{"to":{
    name: _vm.name,
    params: Object.assign({}, {orgId: _vm.$route.params.orgId}, _vm.params)
  }}},[_vm._t("icon",[_c('i',{staticClass:"fe",class:_vm.icon})]),_vm._v(" "+_vm._s(_vm.label || _vm.name)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }